import { Input, Button } from "@ui";
import { Form, Formik } from "formik";
import style from "./ResetPasswordPage.module.scss";
import * as Yup from 'yup';
import { useNavigate, useParams } from "react-router-dom";
import { useResetPasswordMutation } from "@RTKQuery/user/auth/auth";

export function ResetPasswordPage() {
    const { token } = useParams();

    const [resetPassword, { isSuccess, error, isLoading, reset }] = useResetPasswordMutation();

    const navigate = useNavigate();

    return (
        <main className={style.page}>
            <p className={style.pageName}>Скидання паролю</p>
            <Formik
                initialValues={{
                    password: "",
                    confirmPassword: ""
                }}
                validationSchema={Yup.object({
                    password: Yup.string()
                        .min(8, "Пароль має містити не менше 8 символів")
                        .required("Пароль - обов'язкове поле"),
                    confirmPassword: Yup.string()
                        .test(
                            "is-equal",
                            "Паролі не збігаються",
                            (value, context) => {
                                return context.parent.password === value
                            },
                        )
                        .min(8, "Пароль має містити не менше 8 символів")
                        .required("Повторити пароль - обов'язкове поле"),
                })}
                onSubmit={(values) => {
                    resetPassword({
                        token: token || "",
                        new_password: values.password,
                        new_password_again: values.confirmPassword
                    })
                }}
            >
                {(props) => (
                    <Form>
                        <div className="flex flex-col gap-[20px] mb-[40px]">
                            <Input
                                label="Новий пароль"
                                type="password"
                                onChange={(newValue) => {
                                    props.setFieldValue("password", newValue.trim())
                                }}
                                onBlur={props.handleBlur}
                                value={String(props.values.password)}
                                name="password"
                                customStyle={{
                                    width: "!max-w-[360px]"
                                }}
                                error={props.touched.password ? props.errors.password : ""}
                            />
                            <Input
                                label="Підтвердження нового паролю"
                                type="password"
                                onChange={(newValue) => {
                                    props.setFieldValue("confirmPassword", newValue.trim())
                                }}
                                onBlur={props.handleBlur}
                                value={String(props.values.confirmPassword)}
                                name="confirmPassword"
                                customStyle={{
                                    width: "!max-w-[360px]"
                                }}
                                error={props.touched.confirmPassword ? props.errors.confirmPassword : ""}
                            />
                        </div>
                        <Button
                            type="submit"
                            color="blue"
                            text="Зберегти"
                            customStyle={{
                                width: "!max-w-full !w-full",
                                button: "!max-w-full !w-full  !px-[45px] !h-[43px] !mb-[40px]",
                                text: "!text-[16px]"
                            }}
                            successContent={
                                isSuccess
                                    ? {
                                        title: "Вітаємо!",
                                        description: <p className="max-w-[260px]">Ви успішно змінили пароль!</p>,
                                        button: {
                                            text: "Увійти",
                                            action: () => {
                                                navigate("../login")
                                                reset();
                                            }
                                        }
                                    }
                                    : undefined
                            }
                            loading={isLoading}
                            errors={[
                                (error && ((extractError) => {
                                    return extractError(error)
                                }))
                            ]}
                            resetStatus={() => {
                                reset();
                            }}
                        />
                    </Form>
                )}
            </Formik>
        </main>
    )
}